// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__ZqIpW","Label":"Input_Label__7eBB4","InputElement":"Input_InputElement__e+yTM","Invalid":"Input_Invalid__zRRnW"};